// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2jF0x"};